import { getDeviceOS } from "@/common/index";
import { isMobile } from "@/utils/utils";

/**
 * 1. 探测 CSS 的 env(safe-area-inset-top) 实际像素高度
 */
export function checkAndApplyTopOffset() {
  const probe = document.createElement("div");
  Object.assign(probe.style, {
    position: "fixed",
    top: "0",
    height: "env(safe-area-inset-top, 0px)",
    visibility: "hidden",
    pointerEvents: "none"
  });
  document.body.appendChild(probe);
  const cssSafeTopPx = probe.clientHeight;
  document.body.removeChild(probe);
  return cssSafeTopPx;
}

/**
 * 2. 动态设置原生顶部安全区 CSS 变量
 */
export function setNativeTopInsetPx(px) {
  const raw = Number(px);
  if (!Number.isFinite(raw)) return;

  const clamped = Math.max(0, Math.min(raw, 120));
  const value = `${clamped}px`;
  const root = document.documentElement;

  root.style.setProperty("--safe-top", value);
  root.style.setProperty("--app-top-offset", value);
  root.classList.toggle("native-top-inset", clamped > 0);
}

/**
 * 3. 提取各种嵌套格式的 statusBar 像素值
 */
export function extractTopInset(payload) {
  if (!payload) return undefined;
  if (typeof payload === "number") return payload;
  if (typeof payload === "string") return Number(payload);

  const candidates = [
    payload.top,
    payload.statusBarHeight,
    payload.height,
    payload.data?.top,
    payload.data?.statusBarHeight,
    payload.data?.height,
  ];

  for (const item of candidates) {
    const n = Number(item);
    if (Number.isFinite(n)) return n;
  }
  return undefined;
}

/**
 * 4. 监听安卓键盘弹起，滚动输入框防遮挡
 */
export function initInputScrollListener() {
  if (getDeviceOS() !== "android" || !isMobile()) return;

  document.addEventListener("focusin", (e) => {
    const { tagName } = e.target;
    if (tagName === "INPUT" || tagName === "TEXTAREA") {
      setTimeout(() => {
        e.target.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 300); 
    }
  });
}

/**
 * 5. 静态常量配置：用于并发请求的映射表
 */
export const AD_CONFIGS = [
  { type: 2, mutation: "setBlackListAd" },
  { type: 3, mutation: "setGrayListAd" },
  { type: 4, mutation: "setAdmissionAd" }
];

export const SYS_CONFIGS = [
  { key: "loanDisbursementMethod", localKey: "lendingModel" },
  { key: "agreementSigningConditions", localKey: "agreementSigningConditions" }
];